import { isMobile } from "react-device-detect";
import { useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useActions } from "../../Hooks/redux/useActions";
import { useAppSelector } from "../../Hooks/redux/useAppSelector";
import ContentProvider from "../ContentProvider";
import PageAside from "../PageAside";
import PageHeader from "../PageHeader";

import MobilePage from "../../Pages/MobilePage";

import AuthContentProvider from "../AuthContentProvider";
import { AppContent, Application } from "./styled";
import "./variables.css";

declare global {
  interface Window {
    grecaptcha: {
      ready(callback: () => void): void;
      execute(
        sitekey: string,
        options: {
          action: string;
        },
      ): Promise<string>;
      // Добавьте другие методы, если необходимо
    };
  }
}

function App() {
  const location = useLocation();
  const { toggleAside } = useActions();

  const openMenu = useAppSelector((state) => state.asideSlice.isOpen);

  const handleHideMenu = () => {
    toggleAside(!openMenu);
  };

  if (isMobile) {
    return <MobilePage></MobilePage>;
  }

  return (
    <Application>
      {location.pathname === "/authorization" ||
      location.pathname.includes("/registration") ||
      location.pathname.includes("/reset-password") ||
      location.pathname.includes("/authByToken") ? (
        <AuthContentProvider />
      ) : (
        <>
          <PageHeader rolled={openMenu} />
          <AppContent data-rolled={openMenu}>
            <PageAside handleHideMenu={handleHideMenu} rolled={openMenu} />
            <ContentProvider />
          </AppContent>
        </>
      )}
      <ToastContainer autoClose={1000} pauseOnFocusLoss={false} />
    </Application>
  );
}

export default App;
